import { render } from "./MonthlyApplicationLeadsChart.vue?vue&type=template&id=392cf832"
import script from "./MonthlyApplicationLeadsChart.vue?vue&type=script&lang=js"
export * from "./MonthlyApplicationLeadsChart.vue?vue&type=script&lang=js"

import "./MonthlyApplicationLeadsChart.vue?vue&type=style&index=0&id=392cf832&lang=scss"
script.render = render

export default script